import React from 'react'
import {MdError} from 'react-icons/md'
export default function Error(msg) {
        
    return (
        <div className="flex items-center my-1 font-semibold text-red-600" >
           <MdError className="mr-2"/><span style={{fontSize:"12px"}} >{msg}</span> 
        </div>
    )
}